var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basicContainer',[_c('el-row',[_c('el-col',{attrs:{"span":"12"}},[_c('avue-form',{attrs:{"option":_vm.option},on:{"submit":_vm.handleSubmit},model:{value:(_vm.obj),callback:function ($$v) {_vm.obj=$$v},expression:"obj"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }